import { all, AllEffect, ForkEffect, put, takeEvery, call, select } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';

import BffApiService from '@/shared/bffApiService';
import {
  getHeroBackgroundsError,
  getHeroBackgroundsSuccess,
  HeroBackgroundsActionType,
} from '@/store/cms/hero-backgrounds/actions';
import { selectBtagPrefix } from '@/store/selectors/commonSelectors';

export function* getHeroBackgroundsSaga(): SagaIterator {
  try {
    const btag = yield select(selectBtagPrefix);
    const response = yield call(BffApiService.getCmsHeroBackgrounds, {
      config: { params: { btag } },
    });
    yield put(getHeroBackgroundsSuccess(response.data.data));
  } catch (error) {
    yield put(getHeroBackgroundsError());
  }
}
export function* watchHeroBackgroundsSagas(): Generator<AllEffect<ForkEffect<never>>, void> {
  yield all([takeEvery(HeroBackgroundsActionType.GetHeroBackgrounds, getHeroBackgroundsSaga)]);
}
